import Cookies from "js-cookie";

export const BASE_URL = process.env.REACT_APP_SERVER_URL;

class Auth {
  getCipher(): string | null {
    return Cookies.get("fibonnaci-store-cipher") || null;
  }

  setCipher(token: string): void {
    Cookies.set("fibonnaci-store-cipher", token);
  }

  clearCipher(): void {
    Cookies.remove("fibonnaci-store-cipher");
  }
}

export default new Auth();
